// extracted by mini-css-extract-plugin
module.exports = {"menu":"index-module--menu--1M8Ky","fadeIn":"index-module--fade-in--2W-ap","nav":"index-module--nav--3U4Ek","link":"index-module--link--2vx0a"};